import React from 'react'
interface CircularCheckboxProps {
  id: number
  label?: string
  checked?: boolean
  disabled?: boolean
  onChange: (id: number) => void
  className?: string
}
export const CircularCheckbox: React.FC<CircularCheckboxProps> = ({
  id,
  label,
  checked,
  disabled,
  onChange,
  className,
}) => {
  return (
    <>
      <div className="relative flex items-center gap-[8px]">
        <label className="relative flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e: any) => {
              e.stopPropagation()
              onChange(id)
            }}
            onClick={(e) => {
              e.stopPropagation() // 중요! 클릭 이벤트 버블링 방지
            }}
            className="sr-only"
            disabled={disabled}
          />
          <div
            className={`w-[20px] h-[20px] rounded-full border-2 bg-main flex items-center justify-center ${
              checked ? 'bg-white border-main' : 'bg-white'
            }`}
          >
            {checked && <div className="w-3 h-3 bg-main rounded-full"></div>}
          </div>
        </label>
        <span
          className={`md:text-[18px] ${className}`}
          style={!checked && disabled ? { opacity: 0.3 } : {}}
        >
          {label}
        </span>
      </div>
    </>
  )
}
